import { render, staticRenderFns } from "./ShopView01.vue?vue&type=template&id=68f02d9a&scoped=true&"
import script from "./ShopView01.vue?vue&type=script&lang=js&"
export * from "./ShopView01.vue?vue&type=script&lang=js&"
import style0 from "./ShopView01.vue?vue&type=style&index=0&id=68f02d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f02d9a",
  null
  
)

export default component.exports